export const CHARGEBACK_STATUS_DEF_GET = "/ChargebackStatusDef/GetAllChargebackStatusDef"